// 活动执行核销列表页查询条件状态管理

const state = {
  defaultQueryCondition: {
    applyNameOrCode: null,
    applyStatus: null,
    planWriteOffStatus: null,
    itemType: null,
    actMonthStart: null,
    actMonthEnd: null,
    budgetData: null,
    planCode: null,
    planApplyCode: null,
    regionIds: [],
    dealerIds: [],
    oneLevelCode: null,
    twoLevelCode: null,
    threeLevelCode: null
  },
  queryCondition: {
    applyNameOrCode: null,
    applyStatus: null,
    planWriteOffStatus: null,
    itemType: null,
    actMonthStart: null,
    actMonthEnd: null,
    budgetData: null,
    planCode: null,
    planApplyCode: null,
    regionIds: [],
    dealerIds: [],
    oneLevelCode: null,
    twoLevelCode: null,
    threeLevelCode: null
  },
  pagination: {
    current: 1,
    size: 20,
    total: 0
  },
  showFilter: false,
  // 五级来源1、2、3级下拉列表
  sourceList: {
    oneSourceList: [],
    twoSourceList: [],
    threeSourceList: []
  },
  defaultSourceList: {
    oneSourceList: [],
    twoSourceList: [],
    threeSourceList: []
  }
}

const mutations = {
  updateQueryCondition: (state, newCondition) => {
    state.queryCondition = newCondition
  },
  resetQueryCondition(state) {
    state.queryCondition = { ...state.defaultQueryCondition }
    state.pagination = {
      current: 1,
      size: 20,
      total: 0
    }
    state.sourceList.twoSourceList = state.defaultSourceList.twoSourceList
    state.sourceList.threeSourceList = state.defaultSourceList.threeSourceList
  },
  updatePagination(state, newPagination) {
    state.pagination = newPagination
  },
  updateShowFilter(state, newState) {
    state.showFilter = newState
  },
  updateSourceList(state, newState) {
    switch (newState.level) {
      case 1:
        state.sourceList.oneSourceList = newState.list
        break
      case 2:
        state.queryCondition.twoLevelCode = null
        state.queryCondition.threeLevelCode = null
        state.sourceList.twoSourceList = newState.list
        break
      case 3:
        state.queryCondition.threeLevelCode = null
        state.sourceList.threeSourceList = newState.list
        break
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
